var _dec, _class, _class2, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { View } from 'react-native';
import { styled } from "../../theme";
export
/**
 * Provides to select a single state from multiple options.
 * RadioGroup should contain Radio components to provide a useful component.
 *
 * @extends React.Component
 *
 * @property {number} selectedIndex - Index of currently checked radio.
 *
 * @property {(number) => void} onChange - Called when one of the radios is pressed.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example RadioGroupSimpleUsage
 */
let RadioGroup = (_dec = styled('RadioGroup'), _dec(_class = (_temp = _class2 = class RadioGroup extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onRadioChange", index => {
      this.props.onChange && this.props.onChange(index);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        itemMarginVertical
      } = source,
            containerParameters = _objectWithoutProperties(source, ["itemMarginVertical"]);

      return {
        container: containerParameters,
        item: {
          marginVertical: itemMarginVertical
        }
      };
    });

    _defineProperty(this, "renderRadioElements", (source, style) => {
      return React.Children.map(source, (element, index) => {
        return /*#__PURE__*/React.cloneElement(element, {
          key: index,
          style: [style, element.props.style],
          checked: this.props.selectedIndex === index,
          onChange: () => this.onRadioChange(index)
        });
      });
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      children
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["eva", "style", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    const radioElements = this.renderRadioElements(children, evaStyle.item);
    return /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [evaStyle.container, style]
    }), radioElements);
  }

}, _defineProperty(_class2, "defaultProps", {
  selectedIndex: -1
}), _temp)) || _class);